import React, {useState} from 'react'
import ReactDOM, {unmountComponentAtNode} from 'react-dom'
import {DataObjectId} from 'yougile-model'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {SelectWithDropdown} from '@components/common/base/select-with-dropdown'
import {SelectWithDropdownProps} from '@components/common/base/select-with-dropdown/select-with-dropdown'
import {UIElement} from '../ui-element'

export class SelectWrapper extends UIElement {
  private props: SelectWithDropdownProps
  private previous: HTMLElement

  constructor(companyId: DataObjectId, props: SelectWithDropdownProps) {
    super(companyId, undefined, undefined)
    this.props = props
  }

  public override render(el: HTMLElement): void {
    el.innerHTML = ''
    el.className = 'ui-button-new'

    this.clean()

    renderElement(el, this.props)
    super.render(el)

    this.previous = el
  }

  public clean() {
    // to avoid memory leaks
    this.previous && unmountComponentAtNode(this.previous)
  }

  public rerender(props?: Partial<SelectWithDropdownProps>) {
    renderElement(this.previous, {...this.props, ...props})
  }
}

const SelectBase = (props: SelectWithDropdownProps) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    props.value
  )

  const onChange = (item: OptionsItem) => {
    setSelectedValue(item.text)
    props.onChange?.(item)
  }

  return (
    <SelectWithDropdown {...props} value={selectedValue} onChange={onChange} />
  )
}

export const renderElement = (
  element: HTMLElement,
  props: SelectWithDropdownProps
) => {
  ReactDOM.render(<SelectBase {...props} />, element)
}
